<template>
    <div class="page">
        <toolbar-system></toolbar-system>
        <progress-system :isLoad="progress"></progress-system>
        <!-- Esse componente serve tanto para os cursos em aberto como para os cursos que o aluno já está matriculado -->
        <v-container>
            <v-card v-if="curso != null">
              <v-card-title>
                <div class="red--text text--darken-1">
                  <h1 class="black--text">{{curso.GradeDescricao}}</h1>
                  <span v-if="this.$route.fullPath.substring(1, 29) == 'aluno/programacao_academica/'">* As datas de início e término do curso estão sujeitas a alteração.</span><br>
                  <span v-if="curso.Esgotado==1 && curso.Matriculado==null" class="red--text text--darken-1">* {{curso.StatusEsgotadoMatriculado}}</span>
                  <span v-else class="green--text text--darken-1">* {{curso.StatusEsgotadoMatriculado}}</span>
                  <br>
                </div>
              </v-card-title>
              <v-card-text>
                <!-- {{curso}} -->

                <strong>APRESENTAÇÃO DO CURSO</strong>
                <div class="pt-3">
                  {{curso.Ementa}}
                </div>
                <br>
                <strong>CARGA HORÁRIA</strong>
                <div class="pt-3">
                  {{curso.CargaHoraria}}
                </div>
                <br>
                <div v-for="(item) in curso.EmentaDetalhe" :key="item.index">
                  <strong>{{item.GrupoEmenta}} </strong>
                  <div class="pt-3">
                    {{item.Detalhe}}
                  </div> <br>
                </div>
                <Strong>CONTEÚDOS PROGRAMÁTICOS</Strong>
                <div class="pt-3">
                  <div v-for="(item) in curso.Conteudos" :key="item.index">
                    {{item.conteudo}}
                  </div>
                </div>
                <br>
                <strong>DISPONIBILIDADE</strong>
                <div class="pt-3">
                  De {{$moment(curso.DataInicial).format('LL')}} a {{$moment(curso.DataFinal).format('LL')}}.
                </div>
                <br>
                <strong>PERÍODO DE INSCRIÇÃO</strong>
                <div class="pt-3">
                  Até {{$moment(curso.limiteInscricao).format('LL')}}
                </div>
                <br>
                <strong>LOCAL</strong>
                <div class="pt-3">
                  {{(curso.Local)}}
                </div>
                <br>
                <strong>HORÁRIO</strong>
                <div class="pt-3">
                  {{curso.HoraInicial + " às " + curso.HoraFinal}}
                </div>
                <br>
                <strong>DIAS</strong>
                <div class="pt-3">
                  <span v-for="dia in curso.Dias" :key="dia.index">{{ dia }}{{dia != 'Sábado' ? ', ' : '.'}}</span>
                </div>
                <br>
                <strong>DOCENTE</strong>
                <div class="pt-3">
                  {{(curso.Docente)}}
                </div>
                <br>
              </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import ToolbarSystem from '../../../components/ToolbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
export default {
    components:{
        ToolbarSystem,
        ProgressSystem
    },
    data () {
        return{
          sideIcon: true,
          progress: true,
          curso: null,
        }
    },
    methods:{
        getCursosAbertosDetalhes (idCurso){
          let token = localStorage.getItem('token')
          let user = '';
          if (token != null){
            user = 'user/';
          }
          this.axios.get(user + 'cursoaberto/' + idCurso).then(res => {
              this.curso = res.data
              // "Traduzindo" os dias
              let dias = this.curso.Dias.split('-')

              dias = dias.map(elem => {
                switch(elem){
                  case '2':     return 'Segunda';
                  case '3':     return 'Terça';
                  case '4':     return 'Quarta';
                  case '5':     return 'Quinta';
                  case '6':     return 'Sexta';
                  case '7':     return 'Sábado';
                  default :     return 'Domingo';
                }
              })
              this.curso.Dias = dias
            
          }).finally(()=>{
              this.progress = false
          })
        },
        getMeusCursos (idUser, idCurso) {
            this.axios.get('user/'+ idUser +'/curso/' + idCurso).then(res => {
                this.curso = res.data
            }).finally(()=>{
                this.progress = false
            })
        },
        getUser () {
            this.axios.get('user/').then( res => {
                this.user = res.data
                this.getMeusCursos(res.data.IdPessoaFisica, this.$route.params.pathMatch)
            })
        }
    },
    mounted(){
        if(this.$route.name == 'detalheCursosAlunoId'){
            //Passando ID do curso pelo valor obtido da rota
            this.getUser()
        }else{
            //Passando ID do curso pelo valor obtido da rota
            this.getCursosAbertosDetalhes(this.$route.params.pathMatch)
        }
    }
}
</script>
